import axios from "axios";
import { BASE_URL } from "../config/config";

export const getCompanyDetails = async () => {
  const res = await axios.get(`${BASE_URL}/company`);
  return res.data?.data;
};
